/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './content-specials.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/di/injector';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/change_detection';
import * as import8 from '../shared/config.service';
import * as import9 from '../shared/notification.service';
import * as import10 from '../shared/utils.service';
import * as import11 from '../shared/content.service';
import * as import12 from '@angular/router/src/router_state';
import * as import13 from '@angular/common/src/location/location';
import * as import14 from '@angular/router/src/router';
import * as import15 from '@angular/core/src/metadata/view';
import * as import16 from '@angular/core/src/linker/component_factory';
import * as import17 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import18 from '@angular/common/src/pipes/date_pipe';
import * as import19 from '@angular/core/src/linker/template_ref';
import * as import20 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import21 from '@angular/core/src/i18n/tokens';
import * as import22 from '@angular/common/src/directives/ng_for';
import * as import23 from '../../../node_modules/@angular/forms/src/directives/checkbox_value_accessor.ngfactory';
import * as import24 from '../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import25 from '../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import26 from '@angular/core/src/linker/element_ref';
import * as import27 from '@angular/forms/src/directives/checkbox_value_accessor';
import * as import28 from '@angular/forms/src/directives/control_value_accessor';
import * as import29 from '@angular/forms/src/directives/ng_model';
import * as import30 from '@angular/forms/src/directives/ng_control';
import * as import31 from '@angular/forms/src/directives/ng_control_status';
export class Wrapper_ContentSpecialsComponent {
  context:import0.ContentSpecialsComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any) {
    this.changed = false;
    this.context = new import0.ContentSpecialsComponent(p0,p1,p2,p3,p4,p5,p6);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_ContentSpecialsComponent_Host:import2.RenderComponentType = (null as any);
class _View_ContentSpecialsComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _ContentSpecialsComponent_0_4:Wrapper_ContentSpecialsComponent;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentSpecialsComponent_Host0,renderType_ContentSpecialsComponent_Host,import6.ViewType.HOST,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.selectOrCreateRenderHostElement(this.renderer,'ng-component',import4.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_ContentSpecialsComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._ContentSpecialsComponent_0_4 = new Wrapper_ContentSpecialsComponent(this.parentInjector.get(import8.ConfigService),this.parentInjector.get(import9.NotificationService),this.parentInjector.get(import10.UtilsService),this.parentInjector.get(import11.ContentService),this.parentInjector.get(import12.ActivatedRoute),this.parentInjector.get(import13.Location),this.parentInjector.get(import14.Router));
    this._appEl_0.initComponent(this._ContentSpecialsComponent_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._ContentSpecialsComponent_0_4.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.ContentSpecialsComponent) && (0 === requestNodeIndex))) { return this._ContentSpecialsComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ContentSpecialsComponent_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    if (!throwOnChange) { this._ContentSpecialsComponent_0_4.context.ngAfterContentChecked(); }
    this._ContentSpecialsComponent_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentSpecialsComponent_Host0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_ContentSpecialsComponent_Host === (null as any))) { (renderType_ContentSpecialsComponent_Host = viewUtils.createRenderComponentType('',0,import15.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_ContentSpecialsComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const ContentSpecialsComponentNgFactory:import16.ComponentFactory<import0.ContentSpecialsComponent> = new import16.ComponentFactory<import0.ContentSpecialsComponent>('ng-component',viewFactory_ContentSpecialsComponent_Host0,import0.ContentSpecialsComponent);
const styles_ContentSpecialsComponent:any[] = ([] as any[]);
var renderType_ContentSpecialsComponent:import2.RenderComponentType = (null as any);
class _View_ContentSpecialsComponent0 extends import1.AppView<import0.ContentSpecialsComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _text_30:any;
  _el_31:any;
  _text_32:any;
  _text_33:any;
  _el_34:any;
  _text_35:any;
  _text_36:any;
  _text_37:any;
  _text_38:any;
  _el_39:any;
  _text_40:any;
  _anchor_41:any;
  /*private*/ _appEl_41:import3.AppElement;
  _TemplateRef_41_5:any;
  _NgFor_41_6:import17.Wrapper_NgFor;
  _text_42:any;
  _text_43:any;
  _text_44:any;
  _text_45:any;
  _text_46:any;
  _text_47:any;
  _text_48:any;
  /*private*/ _expr_52:any;
  /*private*/ _expr_53:any;
  _pipe_date_0:import18.DatePipe;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentSpecialsComponent0,renderType_ContentSpecialsComponent,import6.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_52 = import7.UNINITIALIZED;
    this._expr_53 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','content-header'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n  ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'h1',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'Parmi les interprètes d\'aujourd\'hui\n    ',(null as any));
    this._text_4 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_5 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n  ',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,' \n',(null as any));
    this._text_8 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_9 = import4.createRenderElement(this.renderer,parentRenderNode,'section',new import4.InlineArray2(2,'class','content'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n  ',(null as any));
    this._el_11 = import4.createRenderElement(this.renderer,this._el_9,'div',new import4.InlineArray2(2,'class','row'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n\n  ',(null as any));
    this._el_13 = import4.createRenderElement(this.renderer,this._el_11,'div',new import4.InlineArray2(2,'class','col-xs-12'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n  ',(null as any));
    this._el_15 = import4.createRenderElement(this.renderer,this._el_13,'div',new import4.InlineArray2(2,'class','box'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'\n    ',(null as any));
    this._el_17 = import4.createRenderElement(this.renderer,this._el_15,'div',new import4.InlineArray2(2,'class','box-body'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n\n      ',(null as any));
    this._el_19 = import4.createRenderElement(this.renderer,this._el_17,'table',new import4.InlineArray2(2,'class','table table-striped table-hover'),(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'\n        ',(null as any));
    this._el_21 = import4.createRenderElement(this.renderer,this._el_19,'thead',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n          ',(null as any));
    this._el_23 = import4.createRenderElement(this.renderer,this._el_21,'tr',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'\n            ',(null as any));
    this._el_25 = import4.createRenderElement(this.renderer,this._el_23,'th',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'Statut',(null as any));
    this._text_27 = this.renderer.createText(this._el_23,'\n            ',(null as any));
    this._el_28 = import4.createRenderElement(this.renderer,this._el_23,'th',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'Date',(null as any));
    this._text_30 = this.renderer.createText(this._el_23,'\n            ',(null as any));
    this._el_31 = import4.createRenderElement(this.renderer,this._el_23,'th',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_32 = this.renderer.createText(this._el_31,'',(null as any));
    this._text_33 = this.renderer.createText(this._el_23,'\n            ',(null as any));
    this._el_34 = import4.createRenderElement(this.renderer,this._el_23,'th',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'',(null as any));
    this._text_36 = this.renderer.createText(this._el_23,'\n          ',(null as any));
    this._text_37 = this.renderer.createText(this._el_21,'\n        ',(null as any));
    this._text_38 = this.renderer.createText(this._el_19,'\n        ',(null as any));
    this._el_39 = import4.createRenderElement(this.renderer,this._el_19,'tbody',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_40 = this.renderer.createText(this._el_39,'\n          ',(null as any));
    this._anchor_41 = this.renderer.createTemplateAnchor(this._el_39,(null as any));
    this._appEl_41 = new import3.AppElement(41,39,this,this._anchor_41);
    this._TemplateRef_41_5 = new import19.TemplateRef_(this._appEl_41,viewFactory_ContentSpecialsComponent1);
    this._NgFor_41_6 = new import17.Wrapper_NgFor(this._appEl_41.vcRef,this._TemplateRef_41_5,this.parentInjector.get(import20.IterableDiffers),this.ref);
    this._text_42 = this.renderer.createText(this._el_39,'\n        ',(null as any));
    this._text_43 = this.renderer.createText(this._el_19,'\n      ',(null as any));
    this._text_44 = this.renderer.createText(this._el_17,'\n\n\n    ',(null as any));
    this._text_45 = this.renderer.createText(this._el_15,'\n  ',(null as any));
    this._text_46 = this.renderer.createText(this._el_13,'\n  ',(null as any));
    this._text_47 = this.renderer.createText(this._el_11,'\n  ',(null as any));
    this._text_48 = this.renderer.createText(this._el_9,'\n',(null as any));
    this._pipe_date_0 = new import18.DatePipe(this.parentInjector.get(import21.LOCALE_ID));
    this.init(([] as any[]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._text_5,
      this._text_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._el_31,
      this._text_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._text_36,
      this._text_37,
      this._text_38,
      this._el_39,
      this._text_40,
      this._anchor_41,
      this._text_42,
      this._text_43,
      this._text_44,
      this._text_45,
      this._text_46,
      this._text_47,
      this._text_48
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import19.TemplateRef) && (41 === requestNodeIndex))) { return this._TemplateRef_41_5; }
    if (((token === import22.NgFor) && (41 === requestNodeIndex))) { return this._NgFor_41_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_41_0_0:any = this.context.contents;
    this._NgFor_41_6.check_ngForOf(currVal_41_0_0,throwOnChange,false);
    this._NgFor_41_6.detectChangesInInputProps(this,this._anchor_41,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_52:any = import4.interpolate(1,'Titre (',this.context.currentLanguage,')');
    if (import4.checkBinding(throwOnChange,this._expr_52,currVal_52)) {
      this.renderer.setText(this._text_32,currVal_52);
      this._expr_52 = currVal_52;
    }
    const currVal_53:any = import4.interpolate(1,'Sous-titre (',this.context.currentLanguage,')');
    if (import4.checkBinding(throwOnChange,this._expr_53,currVal_53)) {
      this.renderer.setText(this._text_35,currVal_53);
      this._expr_53 = currVal_53;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
export function viewFactory_ContentSpecialsComponent0(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<import0.ContentSpecialsComponent> {
  if ((renderType_ContentSpecialsComponent === (null as any))) { (renderType_ContentSpecialsComponent = viewUtils.createRenderComponentType('',0,import15.ViewEncapsulation.None,styles_ContentSpecialsComponent,{})); }
  return new _View_ContentSpecialsComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_ContentSpecialsComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _CheckboxControlValueAccessor_6_3:import23.Wrapper_CheckboxControlValueAccessor;
  _NG_VALUE_ACCESSOR_6_4:any[];
  _NgModel_6_5:import24.Wrapper_NgModel;
  _NgControl_6_6:any;
  _NgControlStatus_6_7:import25.Wrapper_NgControlStatus;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _el_18:any;
  _text_19:any;
  _text_20:any;
  /*private*/ _expr_26:any;
  /*private*/ _expr_27:any;
  /*private*/ _expr_28:any;
  _pipe_date_0_0:any;
  /*private*/ _expr_30:any;
  /*private*/ _expr_31:any;
  constructor(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentSpecialsComponent1,renderType_ContentSpecialsComponent,import6.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_26 = import7.UNINITIALIZED;
    this._expr_27 = import7.UNINITIALIZED;
    this._expr_28 = import7.UNINITIALIZED;
    this._expr_30 = import7.UNINITIALIZED;
    this._expr_31 = import7.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import4.createRenderElement(this.renderer,(null as any),'tr',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import4.createRenderElement(this.renderer,this._el_0,'td',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._el_4 = import4.createRenderElement(this.renderer,this._el_2,'div',new import4.InlineArray2(2,'class','switch material-switch'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                  ',(null as any));
    this._el_6 = import4.createRenderElement(this.renderer,this._el_4,'input',new import4.InlineArray2(2,'type','checkbox'),(null as any));
    this._CheckboxControlValueAccessor_6_3 = new import23.Wrapper_CheckboxControlValueAccessor(this.renderer,new import26.ElementRef(this._el_6));
    this._NG_VALUE_ACCESSOR_6_4 = [this._CheckboxControlValueAccessor_6_3.context];
    this._NgModel_6_5 = new import24.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_6_4);
    this._NgControl_6_6 = this._NgModel_6_5.context;
    this._NgControlStatus_6_7 = new import25.Wrapper_NgControlStatus(this._NgControl_6_6);
    this._text_7 = this.renderer.createText(this._el_4,'\n                  ',(null as any));
    this._el_8 = import4.createRenderElement(this.renderer,this._el_4,'label',new import4.InlineArray2(2,'class','label-primary'),(null as any));
    this._text_9 = this.renderer.createText(this._el_4,'\n                ',(null as any));
    this._text_10 = this.renderer.createText(this._el_2,'\n            ',(null as any));
    this._text_11 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_12 = import4.createRenderElement(this.renderer,this._el_0,'td',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_15 = import4.createRenderElement(this.renderer,this._el_0,'td',new import4.InlineArray2(2,'class','pointer'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'',(null as any));
    this._text_17 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_18 = import4.createRenderElement(this.renderer,this._el_0,'td',import4.EMPTY_INLINE_ARRAY,(null as any));
    this._text_19 = this.renderer.createText(this._el_18,'',(null as any));
    this._text_20 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_6,'click',this.eventHandler(this._handle_click_6_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_6,'ngModelChange',this.eventHandler(this._handle_ngModelChange_6_1.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_6,'change',this.eventHandler(this._handle_change_6_2.bind(this)));
    var disposable_3:Function = this.renderer.listen(this._el_6,'blur',this.eventHandler(this._handle_blur_6_3.bind(this)));
    const subscription_0:any = this._NgModel_6_5.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_6_1.bind(this)));
    this._pipe_date_0_0 = import4.pureProxy2((<_View_ContentSpecialsComponent0>this.parent)._pipe_date_0.transform.bind((<_View_ContentSpecialsComponent0>this.parent)._pipe_date_0));
    var disposable_4:Function = this.renderer.listen(this._el_15,'click',this.eventHandler(this._handle_click_15_0.bind(this)));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._text_20
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4
    ]
    ,[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import27.CheckboxControlValueAccessor) && (6 === requestNodeIndex))) { return this._CheckboxControlValueAccessor_6_3.context; }
    if (((token === import28.NG_VALUE_ACCESSOR) && (6 === requestNodeIndex))) { return this._NG_VALUE_ACCESSOR_6_4; }
    if (((token === import29.NgModel) && (6 === requestNodeIndex))) { return this._NgModel_6_5.context; }
    if (((token === import30.NgControl) && (6 === requestNodeIndex))) { return this._NgControl_6_6; }
    if (((token === import31.NgControlStatus) && (6 === requestNodeIndex))) { return this._NgControlStatus_6_7.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import7.ValueUnwrapper();
    this._CheckboxControlValueAccessor_6_3.detectChangesInInputProps(this,this._el_6,throwOnChange);
    const currVal_6_1_0:any = import4.interpolate(1,'',this.context.$implicit._id,'');
    this._NgModel_6_5.check_name(currVal_6_1_0,throwOnChange,false);
    const currVal_6_1_1:any = this.context.$implicit.active;
    this._NgModel_6_5.check_model(currVal_6_1_1,throwOnChange,false);
    this._NgModel_6_5.detectChangesInInputProps(this,this._el_6,throwOnChange);
    this._NgControlStatus_6_7.detectChangesInInputProps(this,this._el_6,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_26:any = import4.interpolate(1,'',this.context.$implicit._id,'');
    if (import4.checkBinding(throwOnChange,this._expr_26,currVal_26)) {
      this.renderer.setElementProperty(this._el_6,'id',currVal_26);
      this._expr_26 = currVal_26;
    }
    this._CheckboxControlValueAccessor_6_3.detectChangesInHostProps(this,this._el_6,throwOnChange);
    this._NgModel_6_5.detectChangesInHostProps(this,this._el_6,throwOnChange);
    this._NgControlStatus_6_7.detectChangesInHostProps(this,this._el_6,throwOnChange);
    const currVal_27:any = import4.interpolate(1,'',this.context.$implicit._id,'');
    if (import4.checkBinding(throwOnChange,this._expr_27,currVal_27)) {
      this.renderer.setElementAttribute(this._el_8,'for',((currVal_27 == (null as any))? (null as any): currVal_27.toString()));
      this._expr_27 = currVal_27;
    }
    valUnwrapper.reset();
    const currVal_28:any = import4.interpolate(1,'',valUnwrapper.unwrap(import4.castByValue(this._pipe_date_0_0,(<_View_ContentSpecialsComponent0>this.parent)._pipe_date_0.transform)(this.context.$implicit.date,'MMM dd yyyy')),'');
    if ((valUnwrapper.hasWrappedValue || import4.checkBinding(throwOnChange,this._expr_28,currVal_28))) {
      this.renderer.setText(this._text_13,currVal_28);
      this._expr_28 = currVal_28;
    }
    const currVal_30:any = import4.interpolate(1,'\n            ',(this.context.$implicit.title? this.context.$implicit.title[this.parent.context.currentLanguage]: '-'),'');
    if (import4.checkBinding(throwOnChange,this._expr_30,currVal_30)) {
      this.renderer.setText(this._text_16,currVal_30);
      this._expr_30 = currVal_30;
    }
    const currVal_31:any = import4.interpolate(1,'',(this.context.$implicit.subtitle? this.context.$implicit.subtitle[this.parent.context.currentLanguage]: '-'),'');
    if (import4.checkBinding(throwOnChange,this._expr_31,currVal_31)) {
      this.renderer.setText(this._text_19,currVal_31);
      this._expr_31 = currVal_31;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._NgModel_6_5.context.ngOnDestroy();
  }
  private _handle_click_6_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>this.parent.context.onStatusChange(!this.context.$implicit.active,this.context.$implicit)) !== false);
    return (true && pd_6_0);
  }
  private _handle_ngModelChange_6_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>(this.context.$implicit.active = $event)) !== false);
    return (true && pd_6_0);
  }
  private _handle_change_6_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>this._CheckboxControlValueAccessor_6_3.context.onChange($event.target.checked)) !== false);
    return (true && pd_6_0);
  }
  private _handle_blur_6_3($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_6_0:any = ((<any>this._CheckboxControlValueAccessor_6_3.context.onTouched()) !== false);
    return (true && pd_6_0);
  }
  private _handle_click_15_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_15_0:any = ((<any>this.parent.context.router.navigate([('special/edit/' + this.context.$implicit._id)],{relativeTo: this.parent.context.route.parent})) !== false);
    return (true && pd_15_0);
  }
}
function viewFactory_ContentSpecialsComponent1(viewUtils:import4.ViewUtils,parentInjector:import5.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentSpecialsComponent1(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/content-specials.component.ngfactory.ts